<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
        }}</span>
        <span class="masge">当前共有{{ total }}条库存</span>
      </div>
      <div class="header">
        <div class="left">
          <!-- <el-button class="btn primary" type="primary" size="small" v-preventReClick
            @click="handleAdd">新增</el-button>
          <el-button class="btn" size="small" :disabled="multiple" v-preventReClick
            @click="handleDelete">
            删除
          </el-button> -->
          <SelectFilter ref="selectFilter" :options="filterOptions" :query="query" @filterChange="filterChange" @reset="reset1"></SelectFilter>
        </div>
        <div class="right">
          <div class="search">
            <el-input type="text" v-model="query.keyWord" @keyup.enter.native="queryChange">
              <i slot="suffix" class="el-icon-search" @click="queryChange"></i>
            </el-input>
            <!-- <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i> -->
          </div>
          <span v-preventReClick @click="reset1">重置</span>
        </div>
      </div>
      <el-tabs v-model="query.category" @tab-click="handleClick" stretch>
        <el-tab-pane v-for="item in StockTypeOptions" :key="item.id" :name="item.id">
          <template slot="label">
            <span style="margin: 0 10px"> {{ item.name }} </span>
          </template>
        </el-tab-pane>
      </el-tabs>
      <el-table ref="multipleTable" border row-key="id" :data="tableData" :max-height="tableHeight" style="width: 100%" @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
        <template slot="empty">
          <div class="empty-div" :style="{ height: tableHeight + 'px' }">
            <img src="../../../../assets/noData.png" width="240" height="240" />
            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
            <div class="empty-rest" @click="reset1">恢复默认</div>
          </div>
        </template>
        <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
        </el-table-column>
        <el-table-column prop="no" label="资产名称" min-width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.fixedAssetName }}</span><br />
            <span>{{ scope.row.fixedAssetNo }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="specName" label="规格型号" min-width="100"></el-table-column>
        <el-table-column v-if="query.category == '0'" prop="warehouseName" label="入库库房" min-width="100"></el-table-column>
        <el-table-column v-if="query.category == '1'" prop="deptName" label="使用科室" min-width="100"></el-table-column>
        <el-table-column v-if="query.category == '2'" show-overflow-tooltip label="库房/科室" min-width="100">
          <template slot-scope="scope">
            <span>{{
              scope.row.deptId ? scope.row.deptName : scope.row.warehouseName
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="unitName" label="单位" min-width="100"></el-table-column>
        <el-table-column prop="assetTypeName" label="资产类型" min-width="100"></el-table-column>
        <el-table-column prop="financeTypeName" label="财务分类" min-width="100"></el-table-column>
        <el-table-column prop="isBuilding" label="是否房屋建筑" min-width="120">
          <template slot-scope="scope">
            <span>{{ getBoolName(scope.row.isBuilding) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="totalNumber" label="总数量" min-width="100"></el-table-column>
        <el-table-column prop="totalAmount" label="总金额" min-width="100">
          <template slot-scope="scope">
            <span>￥{{ toDecimal(scope.row.totalAmount, 2) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="operation" label="操作" width="100">
          <template slot-scope="scope">
            <el-button type="text" v-preventReClick @click="handleInfo(scope.row)" class="color-blue">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange" :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { GetFixedAssetStocks } from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import { AcceptStatusOptions, StockTypeOptions } from "@/enum";
import SelectFilter from "@/components/table-select-filter";
import BaseListMixin from '@/mixin/baseList-mixin.js'

export default {
  mixins: [GetDataMixin, BaseListMixin],
  components: {
    // Info
    SelectFilter,
  },
  data () {
    return {
      GetDatasAction: GetFixedAssetStocks,
      // RemoveAction: RemoveBadEvent,
      // PrintAction: GetAcceptInStockPrintData,
      // editPath: 'bad-event-edit',
      // 查询条件
      query: {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        category: "2",
      },
      // // 列表数据
      // tableData: [],
      // // 列表总数
      // total: 0,
      // // 弹出框标题
      // title: "",
      // // 弹出编辑框
      // open: false,
      // // 打开详情
      // showInfo: false,
      // id: 0,
      // // 新增、编辑的数据
      // form: {},
      // // 多选框数据
      // ids: [],
      // multipleSelection: [],
      // // 列表多选
      // multiple: true,
      AcceptStatusOptions: AcceptStatusOptions,
      StockTypeOptions: StockTypeOptions,
      filterOptions: [
        {
          name: "资产名称/规格",
          type: "select",
          code: "assetId",
          filterMethod: this.getFixedAssets,
          data: [],
        },
        {
          name: "资产类型",
          type: "selectTree",
          code: "assetTypeId",
          filterMethod: this.getFixedAssetTrees,
          data: [],
          defaultProps: {
            children: "children",
            label: "name",
          },
          text: "",
          // filterable: true,
        },
        {
          name: "财务分类",
          type: "selectTree",
          code: "financeTypeId",
          filterMethod: this.getFinanceTypes,
          data: [],
          defaultProps: {
            children: "children",
            label: "name",
          },
          text: "",
        },
        {
          name: "库房",
          type: "select",
          code: "warehouseId",
          filterMethod: this.getWarehouses,
          data: [],
        },
        {
          name: "科室",
          type: "select",
          code: "deptId",
          filterMethod: this.getDepts,
          data: [],
        },
      ],
    };
  },
  methods: {
    // handleSelectionChange (selection) {
    //   this.multipleSelection = selection;
    //   this.ids = selection.map((item) => item.id);
    //   this.multiple = !selection.length;
    // },
    // refenceQuery () {
    //   this.query = {
    //     keyWord: "",
    //     pageSize: 10,
    //     pageIndex: 1,
    //     category: "2",
    //   };
    //   if (this.$refs["selectFilter"]) {
    //     this.$refs["selectFilter"].resetQuery();
    //   }
    // },
    // // 获取列表
    // getData () {
    //   GetFixedAssetStocks(this.query).then((res) => {
    //     this.tableData = res.returnData.data;
    //     this.total = res.returnData.totalCount;
    //   });
    // },
    // // 查看信息
    // handleInfo (row) {
    //   this.$router.push("/fixed-asset-stock-info?id=" + row.id);
    //   // this.id = row.id
    //   // this.showInfo = true
    // },
    // // 改变当前页
    // changePage (val) {
    //   this.$set(this.query, "pageIndex", val);
    //   this.getData();
    // },
    // handleSizeChange (val) {
    //   this.$set(this.query, "pageSize", val);
    //   this.getData();
    // },
    // 重置
    reset1 () {
      this.query = {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        category: "2",
        orgCode :sessionStorage.getItem('orgId')
      };
      if (this.$refs["selectFilter"]) {
        this.$refs["selectFilter"].resetQuery();
      }
      this.ids = []
      this.multipleSelection = []
      this.multiple = true;

      if (this.$refs.multipleTable) {
        this.$refs.multipleTable.clearSelection()
      }
      this.getData();
    },
    // queryChange () {
    //   this.$set(this.query, "pageIndex", 1);
    //   this.getData();
    // },
    filterChange (query) {
      this.query = Object.assign(this.query, query);
      this.getData();
    },
    /**
     * tab选择
     */
    handleClick (e) {
      this.ids = []
      this.multipleSelection = []
      this.multiple = true;

      if (this.$refs.multipleTable) {
        this.$refs.multipleTable.clearSelection()
      }
      // this.$refs["selectFilter"].resetQuery();
      this.$set(this.query, "pageIndex", 1);
      // this.query = {
      //   keyWord: "",
      //   pageSize: 10,
      //   pageIndex: 1,
      //   category: this.query.category,
      // };
      this.getData();
    },
  },
  mounted () { },
  /** 生命周期 - 创建完成（可以访问当前this实例） */
  created () {
    // this.getData();
  },
};
</script>

<style lang="scss" scoped>
.el-tabs {
  width: 470px;
  margin-bottom: 10px;
}
</style>
